const initialState = {
  countriesList: []
}
export default {
  namespaced: true,
  state: Object.assign({}, initialState),
  mutations: {
    resetStateData(state) {
      for (let prop in state) {
        state[prop] = initialState[prop]
      }
    },
    setCountries(state, data) {
      state.countriesList = data
    }
  },
  actions: {
    resetStateData({ commit }) {
      commit('resetStateData')
    },
    getCountriesList({ dispatch, commit }) {
      return dispatch(
        'app/makeCall',
        {
          route: 'countries.getList'
        },
        { root: true }
      ).then((response) => {
        commit('setCountries', response.data)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/countries.js